import { render, staticRenderFns } from "./TableCollapse.vue?vue&type=template&id=0f222f50&scoped=true"
import script from "./TableCollapse.vue?vue&type=script&lang=js"
export * from "./TableCollapse.vue?vue&type=script&lang=js"
import style0 from "pretty-checkbox/dist/pretty-checkbox.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TableCollapse.vue?vue&type=style&index=1&id=0f222f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f222f50",
  null
  
)

export default component.exports